import { MAIL_STATUSES } from 'cpool-constants';
import { schemaId } from 'cpool-schemas';
import { z } from 'zod';

export const LoanRequestMailStatusesTableZodDefinition = z.object({
    correlationId: schemaId,
    error: z.string().optional(),
    loanRequestId: schemaId,
    processedAt: z.number().nullable(),
    status: z.nativeEnum(MAIL_STATUSES),
});

export type LoanRequestMailStatusesSchema = z.infer<typeof LoanRequestMailStatusesTableZodDefinition>;
